import React, {useState,useEffect,useContext} from 'react'
import {useParams} from 'react-router-dom'
import {getFirestore} from '../../Firebase/Firebase'
import PageError from '../pageerror/PageError'
import loader from '../../img/loading-dog.gif';
import './orders.css'
import OrdersAnony from './OrdersAnony';
import OrderUser from './OrderUser';
import { UserContext } from '../../context/UserProvider';

//muestra toda la logica de busqueda para la orden, si el usuario no esta logueado mostrara de forma anonima y 
//caso contrario mostrara con mas detalles, si el 
//usuario esta logueado perono es el titular se mostrara una orden anonima!
 const MyOrder = () => {
    const {user} = useContext(UserContext)
    const {id} = useParams()
    const [items, setItems] = useState([])
    const [buyer, setBuyer] = useState([])
    const [logue , setLogue] = useState(false)
    const [status, setStatus]= useState('')
    const [actu , setActu] = useState("status")
    const [error , setError] = useState(false)
    const [noTitular, setNoTitular] = useState(false)
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const db = getFirestore();
        const orderCollection = db.collection('orders').doc(id);
          orderCollection.get()
          .then(res=>{
              if(!res.exists){
                  setError(true)
              }
            setItems({cart: res.data().items, total: res.data().total, date:res.data().date.toDate()})
            setBuyer(res.data().buyer[0])
            setStatus(res.data().status)
            setLoading(true)
          })
            .catch((err)=>console.log('ocurrio un error', err))
            .finally(()=>console.log('finalizo'))    
          }, [id]);

          useEffect(() => {

            if(user && buyer){
                if(user.email == buyer.email){
                    setLogue(true)
              }else{
                  setNoTitular(true)
                  
              }
            }
          }, [user,buyer,error])

          function showLoading(){
            const db = getFirestore();
            const orderCollection = db.collection('orders').doc(id);
                    setTimeout(()=>{
                        orderCollection.update({status: 'Orden Fianalizada!'})
                        orderCollection.get()
                        .then(res=>{setStatus(res.data().status)})
                        setActu("status2")
                    }, 5000)
            }

            const fecha =(x)=>{
                if(x){
                return `${x.getDate()}/${(x.getMonth()+1)}/${x.getFullYear()} -${x.getHours()}:${x.getMinutes()}hs`
                }
            }


    return (
        <>
        {error ? <PageError mensaje= 'No se ha Encontrado!'/> :

        !loading ? <img src={loader} className="loader-order" alt="loader"/> :

        logue ? <OrderUser id={id} buyer={buyer} fecha={fecha} showLoading={showLoading} status={status} actu={actu} items={items}/> :

        <OrdersAnony id={id} fecha={fecha} status={status} items={items} logue={logue} noTitular={noTitular}/>}
      
        </>
    )
}
export default MyOrder;